module.exports = __webpack_public_path__ + "img/social.d330018.svg";